// Step validation for the two-tab Add Employee dialogs (Personal → Employment).
import type { FieldErrors, UseFormReturn } from "react-hook-form";
import { emptyAddressFields } from "@/lib/address";

export type AddEmployeeTab = "personal" | "employment";

/** Fields rendered on the Personal tab. */
export const ADD_EMPLOYEE_PERSONAL_FIELDS: string[] = [
  "firstName",
  "lastName",
  "personalEmail",
  "phone",
  "dateOfBirth",
  "sex",
  "ssn",
  ...Object.keys(emptyAddressFields()),
];

/** Validate the Personal tab; true when the user may advance. */
export function validatePersonalStep(form: UseFormReturn<any>): Promise<boolean> {
  return form.trigger(ADD_EMPLOYEE_PERSONAL_FIELDS, { shouldFocus: true });
}

/** Tab holding the first validation error, so a failed submit can show it. */
export function tabWithErrors(errors: FieldErrors): AddEmployeeTab {
  return ADD_EMPLOYEE_PERSONAL_FIELDS.some((f) => errors[f]) ? "personal" : "employment";
}
